export { default as beers } from './beers';


/** WEBPACK FOOTER **
 ** ./reducers/index.js
 **/